export default {
  login: {
    tabTitle: "ログイン",
    button: {
      login: "ログイン",
    },
    text: {
      form: {
        emailAddress: "メールアドレス",
        password: "パスワード",
      },
      footer: {
        companyName: "FLUX Inc.",
        privacyPolicy: "プライバシーポリシー",
      },
      forgetPassword: "パスワードの再発行はこちら",
    },
  },
};
